import React from 'react';
import { IconProps } from './types';

const TrainingAgentIcon: React.FC<IconProps> = props => {
  const { size = '24', fillColor = 'var(--violet-base)' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="22" height="22" rx="11" fill={fillColor} />
      <rect x="1" y="1" width="22" height="22" rx="11" stroke="white" strokeWidth="2" />
      <path
        d="M8.62021 9.40625V8.27273H15.3745V9.40625H12.6515V17H11.339V9.40625H8.62021Z"
        fill="white"
      />
    </svg>
  );
};

export default TrainingAgentIcon;
